"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var common_1 = require("@angular/common");
var ng2_tab_component_1 = require("./ng2-tab.component");
exports.Ng2TabComponent = ng2_tab_component_1.Ng2TabComponent;
var Ng2TabModule = (function () {
    function Ng2TabModule() {
    }
    return Ng2TabModule;
}());
Ng2TabModule = __decorate([
    core_1.NgModule({
        imports: [common_1.CommonModule, forms_1.FormsModule],
        declarations: [ng2_tab_component_1.Ng2TabComponent],
        exports: [ng2_tab_component_1.Ng2TabComponent]
    }),
    __metadata("design:paramtypes", [])
], Ng2TabModule);
exports.Ng2TabModule = Ng2TabModule;
//# sourceMappingURL=ng2-tab.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-tab/dist/ng2-tab.module.js
// module id = 90
// module chunks = 0